import { Theme, css } from '@emotion/react';

export const waitlistMetaItem = ({ spacing }: Theme) => {
  return css`
    align-items: center;
    display: flex;
    text-align: left;
    * {
      margin-right: ${spacing(0.5)}px;
    }
  `;
};

export const waitlistMetaContainer = ({ spacing, colors }: Theme) => css`
  background: ${colors.bgLight};
  padding: ${spacing(2)}px;
  margin: ${spacing(2)}px 0;
`;

export const successTitle = ({ spacing, colors }: Theme) => css`
  display: flex;
  align-items: center;

  & svg {
    margin-left: ${spacing(1)}px;
    color: ${colors.fgSuccessBase};
  }
`;
